import { Cell } from '@/grid/Cell';
import { Cluster } from './Cluster';

export class EntrancePoint {
  readonly id: number;
  readonly cell1: Cell;
  readonly cell2: Cell;
  readonly cluster1: Cluster;
  readonly cluster2: Cluster;

  constructor(
    id: number,
    cell1: Cell,
    cell2: Cell,
    cluster1: Cluster,
    cluster2: Cluster
  ) {
    this.id = id;
    this.cell1 = cell1;
    this.cell2 = cell2;
    this.cluster1 = cluster1;
    this.cluster2 = cluster2;
  }

  get isTransitionable(): boolean {
    return this.cell1.isWalkable && this.cell2.isWalkable;
  }

  getCenter(): Cell {
    return this.cell1;
  }

  connects(cluster: Cluster): boolean {
    return this.cluster1.id === cluster.id || this.cluster2.id === cluster.id;
  }

  getOtherCluster(cluster: Cluster): Cluster | null {
    if (this.cluster1.id === cluster.id) {
      return this.cluster2;
    }
    if (this.cluster2.id === cluster.id) {
      return this.cluster1;
    }
    return null;
  }
}
